import { useCallback } from 'react'

import { AfterSalesStatusEnum } from 'enums/AfterSalesStatus'
import html2canvas from 'html2canvas'
import { Icons } from 'utils/icons'
import LogoInter from 'assets/img/logoInter.png'
import LogoPetlove from 'assets/img/logoPetlove.png'
import { PetTypeEnum } from 'enums/PetType'
import BaseBridge from 'config/bridge/BaseBridge'
import { useLocalErrorHandler } from 'hooks/useLocalErrorHandler'

import { Flex } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { Button } from '@interco/inter-ui/components/Button'

import { AfterSalesStatusTag } from '../AfterSales/AfterSalesStatusTag/AfterSalesStatusTag'
import { BottomSheetDetails, PetAvatar, BottomSheetLogo } from './AfterSalesDetails.styles'

interface IPetPlanCardProps {
  hideShare?: boolean
  type: PetTypeEnum
  name: string
  status: AfterSalesStatusEnum
  planName: string
  socialId: string
  petDateBirth: string
}

export const PetPlanCard = ({
  hideShare = false,
  type,
  name,
  status,
  planName,
  socialId,
  petDateBirth,
}: IPetPlanCardProps) => {
  const handlerError = useLocalErrorHandler()
  const icons = {
    share: <Icons.Share width={24} height={24} color="var(--primary500)" />,
  }
  const shareImageAction = useCallback(async () => {
    const element = document.getElementById('print-pet-subscription-card')
    if (!element) {
      return
    }

    const scale = window.devicePixelRatio
    const options = {
      scale,
      useCORS: true,
      allowTaint: true,
      logging: true,
      letterRendering: true,
      windowWidth: element.scrollWidth * scale,
      windowHeight: element.scrollHeight * scale,
    }

    await html2canvas(element, options)
      .then((canvas) => {
        const data = canvas.toDataURL('image/jpg', 1.0)
        BaseBridge.shareImageAction(data.replace('data:image/png;base64,', ''))
      })
      .catch((error) => {
        handlerError(error as Error, 'PetPlanCard.html2canvas')
      })
  }, [])

  return (
    <BottomSheetDetails>
      <Flex direction="column" gap="16px">
        <Flex direction="row" justifyContent="space-between" alignItems="center">
          <Flex direction="row" gap="8px" justifyContent="flex-start" alignItems="center">
            <PetAvatar type={type} />
            <Text variant="body-2" bold>
              {name}
            </Text>
          </Flex>
          {!hideShare && (
            <Button
              aria-label="Compartilhar carteirinha"
              variant="link"
              onClick={shareImageAction}
              style={{ padding: '0px' }}
            >
              {icons.share}
            </Button>
          )}
        </Flex>
        <Flex direction="row" style={{ marginTop: '20px' }}>
          <Text variant="caption-1">Status:</Text>
          <Text variant="caption-1" bold colorWeight={500}>
            <AfterSalesStatusTag status={status} />
          </Text>
        </Flex>
        <Flex direction="row">
          <Text variant="caption-1">Plano:</Text>
          <Text variant="caption-1" bold colorWeight={500}>
            {planName}
          </Text>
        </Flex>
        <Flex direction="row">
          <Text variant="caption-1">Nº identificação (CPF do tutor):</Text>
          <Text variant="caption-1" bold colorWeight={500}>
            {socialId}
          </Text>
        </Flex>
        <Flex direction="row">
          <Text variant="caption-1">Data de nascimento:</Text>
          <Text variant="caption-1" bold colorWeight={500}>
            {petDateBirth}
          </Text>
        </Flex>
      </Flex>
      <Flex direction="row" gap="16px" justifyContent="center" style={{ marginTop: '32px' }}>
        <BottomSheetLogo imagePath={LogoInter} />
        <BottomSheetLogo imagePath={LogoPetlove} />
      </Flex>
    </BottomSheetDetails>
  )
}
